import { useMutation, useQueryClient } from '@tanstack/react-query'
import { api } from 'api'
import { toaster } from 'uikit/Toaster'

export const useClearChache = (userId: string) => {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: () => api.users.clearTransactionsCache(userId),
    onSuccess: () => {
      toaster.create({
        type: 'success',
        title: 'Лимит успешно сброшен',
      })

      queryClient.invalidateQueries({ queryKey: ['fetchUserBalance'] })
    },
    onError: (err: any) => {
      toaster.create({
        type: 'error',
        title: 'Произошла ошибка при сбросе лимита',
        description: err.response?.data?.message || err.message,
      })
    },
  })
}
